export default __webpack_public_path__ + "images/c3e93b1341751389cc599258dbf7d4c2.png";